import { ref } from 'vue';

const globalError = ref<string | null>(null);
const globalErrorCode = ref<string | null>(null);

export function useGlobalError() {
  const setError = (error: string | null) => {
    globalError.value = error;
  };
  const setErrorCode = (error: string | null) => {
    globalErrorCode.value = error;
  };
  const clearError = () => {
    globalError.value = null;
  };
  const clearErrorCode = () => {
    globalErrorCode.value = null;
  };
  return {
    globalError,
    globalErrorCode,
    setError,
    setErrorCode,
    clearError,
    clearErrorCode,
  };
}
